<ng-template #content><ng-content></ng-content></ng-template>

<div class="message-box-component">
  <div [ngClass]="{
          details: type === 'details',
          info: type === 'info',
          danger: type === 'danger',
          warn: type === 'warn',
          disable: type === 'disable',
          'drawdown-submitted': type === 'drawdown-submitted',
          'promo-style1': type === 'promo-style1',
          'promo-style2': type === 'promo-style2',
          success: type === 'success'
       }">
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
      @if (type !== 'promo-style1') {
        <div class="icon ml-3">
          @if (type === 'details') {
            <span class="mdi mdi-account-circle-outline"></span>
          }
          @if (type === 'info') {
            <span class="mdi mdi-information-outline"></span>
          }
          @if (type === 'disable') {
            <span class="mdi mdi-information-outline"></span>
          }
          @if (type === 'danger') {
            <span class="mdi mdi-alert-box-outline"></span>
          }
          @if (type === 'warn') {
            <span class="mdi mdi-help-circle-outline"></span>
          }
          @if (type === 'drawdown-submitted') {
            <span class="mdi mdi-forwardburger"></span>
          }
          @if (type === 'promo-style2') {
            <span class="mdi mdi-gift-outline"></span>
          }
          @if (type === 'success') {
            <span class="mdi mdi-check-circle-outline"></span>
          }
        </div>
      }
      @if (!!!title) {
        <div fxLayout="column" class="content">
          @if (type !== 'promo-style2') {
            <div class="message mat-body">
              <ng-container *ngTemplateOutlet="content"></ng-container>
              @if (image) {
                <div>
                  <img [src]="image" class="image"/>
                </div>
              }
              @if (url) {
                <div class="icon">
                  <span class="mdi mdi-arrow-top-right" (click)="onClickUrl()"></span>
                </div>
              }
            </div>
          }
          @if (type === 'promo-style2') {
            <div class="message mat-body" fxLayout="row" fxLayoutAlign="space-between center">
              <div fxLayout="row">
                <ng-container *ngTemplateOutlet="content"></ng-container>
                @if (url) {
                  <div>
                    <div class="learn-more" (click)="onClickUrl()">Learn more</div>
                  </div>
                }
              </div>
              @if (type === 'promo-style2') {
                <div class="close-icon">
                  <span class="mdi mdi-close" (click)="onClose()"></span>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (title) {
        <div fxLayout="column">
          <div class="title mat-h4-custom mb-1">
            {{title}}
          </div>
          <div>
            <div class="content" fxLayout="column">
              <div class="message mat-body">
                <ng-container *ngTemplateOutlet="content"></ng-container>
              </div>
            </div>
          </div>
        </div>
      }

      @if (showRefresh) {
        <div fxLayout="column" fxFlex="1 1 auto" fxLayoutAlign="center end">
          <mat-icon (click)="onRefreshClick()" style="cursor: pointer;">refresh</mat-icon>
        </div>
      }
    </div>
  </div>
</div>
